const getOptions = (after, options, before = "") => {
  return options.map((label) => {
    const parameter = [before, label, after].filter((val) => val).join(" ");

    return { label, value: parameter };
  });
};

export const ICON_OPTIONS = [
  { label: "Icons", value: false },
  { label: "Emojis", value: true },
];

export const TONE_OPTIONS = getOptions("tone", [
  "Confident",
  "Emotional",
  "Formal",
  "Friendly",
  "Humorous",
  "Informal",
  "Optimistic",
  "Serious",
  "Sympathetic",
  "Warm",
]);

export const LANGUAGE_OPTIONS = getOptions("language", [
  "Albanian",
  "Arabic",
  "Armenian",
  "Azerbaijani",
  "Belarusian",
  "Bosnian",
  "Bulgarian",
  "Catalan",
  "Chinese",
  "Croatian",
  "Czech",
  "Danish",
  "Dutch",
  "English",
  "Estonian",
  "Finnish",
  "French",
  "Georgian",
  "German",
  "Greek",
  "Hindi",
  "Hungarian",
  "Icelandic",
  "Irish",
  "Italian",
  "Japanese",
  "Kazakh",
  "Korean",
  "Latin",
  "Latvian",
  "Lithuanian",
  "Luxembourgish",
  "Macedonian",
  "Maltese",
  "Montenegrin",
  "Norwegian",
  "Polish",
  "Portuguese",
  "Romanian",
  "Romansh",
  "Russian",
  "Serbian",
  "Slovak",
  "Slovenian",
  "Spanish",
  "Swedish",
  "Turkish",
  "Ukrainian",
]);
